/**
 * Sorts object entries based on a preferred order of keys.
 * Keys in the preferred order will appear first, followed by other keys in their original order.
 * @param entries - Array of [key, value] pairs from Object.entries()
 * @param preferredKeys - Array of keys in the desired order
 * @returns Sorted array of [key, value] pairs
 */
export const sortObjectEntries = (
  entries: [string, unknown][],
  preferredKeys: string[],
): [string, unknown][] => {
  return [...entries].sort(([keyA], [keyB]) => {
    const indexA = preferredKeys.indexOf(keyA);
    const indexB = preferredKeys.indexOf(keyB);
    if (indexA === -1 && indexB === -1) return 0; // Keep original order for non-preferred keys
    if (indexA === -1) return 1; // Move non-preferred keys to end
    if (indexB === -1) return -1; // Move preferred keys to start
    return indexA - indexB; // Sort preferred keys by their defined order
  });
};
